import React from 'react';
import {connect} from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';
import { withStyles,Button } from '@material-ui/core';
import Red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';

import { clearMessage } from '../actions/messages';
import {TYPES} from '../reducers/messages';
import { FormattedMessage } from 'react-intl';

const styles = theme => ({
    snackbar: {
        margin: theme.spacing.unit,
    },
    snackbarError: {
        margin: theme.spacing.unit,
        backgroundColor: Red[800],
    },
    buttonError: {
        color: 'white'
    },
    button: {
        color: blue[500],
    }
})

/**
 * Card content displaying info messages such as confirmations
 * when an item has been updated
 */

class MessagesSnacks extends React.Component {

    render() {
        const { messages, open, classes, handleOk} = this.props;
        
        return (
            (messages || []).map((msg, i) =>
                <Snackbar
                    key={i}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={open}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                        className: msg.error? classes.snackbarError : classes.snackbar,
                    }}
                    message={
                        (msg.errors && msg.errors[0]) 
                        ? <div>{msg.errors[0].message}</div>
                        : <FormattedMessage id={msg.content} values={{value: msg.value? msg.value : null}}/>
                    }
                    action={[
                        <Button key="undo" className={msg.error? classes.buttonError : classes.button} size="small" onClick={() => handleOk(i)}>
                            dismiss
                        </Button>,
                    ]}
                />
            )   
        );
    }
}

const mapStateToProps = ({messages}) => {
    const snackMessages = messages.filter( message => message.type === TYPES.SNACK );
    const open = snackMessages.length > 0;
    return {
        messages: snackMessages,
        open
    }
};
const mapDispatchToProps = dispatch => ({
    handleOk: (msgId) => 
        dispatch( clearMessage(msgId) ),
})

export default withStyles(styles)(
    connect( 
      mapStateToProps,
      mapDispatchToProps
    )(MessagesSnacks)
  );


// WEBPACK FOOTER //
// ./src/components/MessagesSnacks.js